import {FC} from 'react';
import {Box, Center} from '@chakra-ui/react';

interface IProps {
  name: string;
}

export const RoleSlot: FC<IProps> = ({name}) => {
  return (
    <Box borderRadius={'8px'} bg={'{colors.bgMain}'}>
      <Center py={'24px'} position={'sticky'} top={0} flexDirection={'column'} gap={'4px'}>
        <Box fontSize={'12px'} lineHeight={'12px'}>
          Role
        </Box>
        <Box fontSize={'14px'} lineHeight={'14px'} fontWeight={'bold'}>
          {name}
        </Box>
      </Center>
    </Box>
  );
};
